import React, { useState } from 'react';
import { Modal } from './Modal';
import { PrivacyPolicy } from './PrivacyPolicy';
import { TermsConditions } from './TermsConditions';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-[#2C2420] text-[#FAF8F4]/60 py-8 px-4" data-id="element-72">
        <div className="max-w-7xl mx-auto" data-id="element-73">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-74">
            <p className="text-sm text-center md:text-left" data-id="element-75">
              © 2024 MASTER HYDRA GLOSS LIPS™ 2.0. Todos los derechos
              reservados.
            </p>

            <div className="flex items-center gap-6 text-sm" data-id="element-76">
              <button onClick={() => setShowPrivacy(true)} className="hover:text-[#E5A5A0] transition-colors underline" data-id="element-77">
                Política de Privacidad
              </button>
              <button onClick={() => setShowTerms(true)} className="hover:text-[#E5A5A0] transition-colors underline" data-id="element-78">
                Términos y Condiciones
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modals */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-79">
        <PrivacyPolicy data-id="element-80" />
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-81">
        <TermsConditions data-id="element-82" />
      </Modal>
    </>;
}